import React from 'react';
import { site } from '@panel/commons/helpers';
import { PriceDualSection } from './priceDual';
import { PriceUniqueSection } from './priceUnique';

const siteId = site.id;

const dualPricePortals = ['DVPE', 'UBPE'];

function PriceSection({ register, errors, control }) {
  return dualPricePortals.includes(siteId) ? (
    <PriceDualSection control={control} siteId={siteId} register={register} errors={errors} />
  ) : (
    <PriceUniqueSection siteId={siteId} register={register} errors={errors} />
  );
}

export { PriceSection };
